<template>
  <div>
    <common-dialog ref="dialog" unit="库位管理" width="1000px" id-key="WarehousePositionId" @close-saved="$emit('close-saved')"
      @closed="$emit('onClosed')" @details-opened="detailsOpened">
      <template slot="form">
        <el-button type="primary" style="margin: 0 0 20px 0" @click="addRow">添加</el-button>
        <el-table ref="table" class="table_bottom table-line tb-c-head" :data="tableData" border>
          <el-table-column prop="WarehouseName" label="仓库名称" min-width="100" align="center" />
          <el-table-column prop="WarehousePositionNo" label="库位编号" min-width="100" align="center">
            <template slot-scope="{ row }">
              <el-input v-model="row.WarehousePositionNo" :disabled="!row.IsEdit"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="WarehousePositionName" label="库位名称" min-width="110" align="center">
            <template slot-scope="{ row }">
              <el-input v-model="row.WarehousePositionName" :disabled="!row.IsEdit"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="Status" label="状态" min-width="60" align="center">
            <template slot-scope="{ row }">
              <el-select v-model="row.Status" :disabled="!row.IsEdit">
                <el-option label="启用" :value="1" key="a2"></el-option>
                <el-option label="停用" :value="0" key="a1"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="Remark" label="备注" min-width="180" align="center">
            <template slot-scope="{ row }">
              <el-input v-model="row.Remark" :disabled="!row.IsEdit"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="120px" v-if="$permission.canWrite()">
            <template slot-scope="{ row, $index }">
              <el-button key="btn2" type="text" @click="onEdit(row)"
                :disabled="row.IsEditBtn">{{ row.IsEdit ? '保存' : '编辑' }}</el-button>
              <el-button type="text" @click="del(row, $index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template slot="footer">
        <el-button @click="close">关闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },

  data() {
    return {
      api: require("@/api/ba/warehousePosition").default,
      code_api: require("@/api/sy/serialCode").default,
      WarehouseId:null,
      tableData: [],
      PreviewNo:null,//编号
      params: {
        Name: "",
      },
    };
  },
  props: {
    WarehouseName: {
      type: String,
      default: '',
    },
  },
  methods: {
    detailsOpened(id) {
      this.WarehouseId = id
      this.api.list({ WarehouseId: id }).then((res) => {
        if (res.Code === 0) {
          res.Data.forEach((item) => {
            item.IsEdit = false;
            item.IsEditBtn = false;
          });
          this.tableData = res.Data;
        }
      });
    },
    close() {
      this.$refs.dialog.close(true);
    },
    serialCode() {
      this.code_api.previewNo("库位").then((res) => {
        if (res.Code == 0) {
          this.PreviewNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取库位编号失败");
        }
      });
    },
    addRow(){
      
      console.log("🚀 ~ this.code_api.previewNo ~ this.WarehouseName:", this.WarehouseName)
      // 需要判断是否是编辑状态
      if(this.tableData.some(item => item.IsEdit)){
        this.$message.warning('请先保存当前编辑的数据');
        return;
      }
      
      this.tableData.forEach((item) => {  this.$set(item, "IsEditBtn", true);});
      this.code_api.previewNo("库位").then((res) => {
        if (res.Code == 0) {
          this.PreviewNo = res.Data.PreviewNo;
          this.tableData.push({
            WarehousePositionNo: this.PreviewNo,
            WarehousePositionName: "",
            WarehouseName: this.WarehouseName,
            Remark: "",
            Status: 1,
            IsEdit: true,
            IsEditBtn: false,
            WarehouseId: this.WarehouseId,
          });
        } else {
          this.$message.warning("获取库位编号失败");
        }
      });

    },
    del({WarehousePositionId}){
      if(WarehousePositionId){
        this.$confirm("确认删除该行数据吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.api.delete({id:WarehousePositionId}).then(res => {
            if (res.Code == 0) {
              this.$message.success("删除成功");
              this.detailsOpened(this.WarehouseId);
            } else {
              this.$message.warning(res.Msg);
            }
          })
        });
      }else{
        this.tableData.splice(this.tableData.length - 1, 1);
        this.tableData.forEach((item) => {
          this.$set(item, "IsEditBtn", false);
        });
      }
    },
    onEdit(row) {
      if (row.IsEdit) {
        console.log('保存');
        const params = {
          WarehouseId: row.WarehouseId,
          WarehousePositionName: row.WarehousePositionName,
          Remark: row.Remark,
          Status: row.Status,
          WarehousePositionNo : row.WarehousePositionNo,
          WarehousePositionId: row.WarehousePositionId
        }
        this.api.save(params).then(res => {
          if (res.Code == 0) {
            this.$message.success("保存成功");
            this.detailsOpened(this.WarehouseId);
            this.$set(row, "IsEdit", false);
          } else {
            this.$message.warning(res.Msg);
          }
        })
      } else {
        console.log('编辑');
        this.tableData.forEach((item) => {
          this.$set(item, "IsEditBtn", true);
        });
        this.$set(row, "IsEdit", true);
        this.$set(row, "IsEditBtn", false);
      }
    },
  },
};
</script>
